import { boolean, define, mask, nullable, number, object, string, trimmed } from 'superstruct';
import { ms } from '@arc/shared/util-js';
import { emptyStringIsNull, matchesField, password, userString } from '@arc/shared/util-superstruct';
export const LOGIN_ATTEMPT_LIMIT = 10;
export const USER_LOCKOUT_TIME = 30 * ms.minutes;

/**
 * Ensure that a value is an email address.
 */
export const emailAddress = (requiredErrorMessage = 'validations:Required') => trimmed(define('Email', (value, context) => {
  let validString;
  try {
    validString = mask(value, trimmed(emptyStringIsNull(string())));
  } catch {
    return {
      message: requiredErrorMessage,
      ...context
    };
  }

  // Taken from https://emailregex.com/
  const emailRegex =
  // eslint-disable-next-line require-unicode-regexp
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRegex.test(validString)) {
    return true;
  } else {
    return {
      message: 'validations:Invalid Email',
      ...context
    };
  }
}));
export const LoginDto = object({
  email: emailAddress(),
  password: userString('validations:Required')
});
export const RequestResetPasswordDto = object({
  email: emailAddress()
});
export const ChangePasswordFormDto = object({
  newPassword: password(),
  confirmPassword: matchesField('newPassword', 'user-form:Passwords do not match.')
});
export const ChangePasswordDto = object({
  newPassword: password(),
  token: string()
});
export const CheckResetPasswordTokenDto = object({
  token: string()
});
export const ResetPasswordTokenInfoDto = object({
  isValidToken: boolean(),
  user: nullable(object({
    id: number(),
    name: string()
  }))
});